import { Bubble, Props as BubbleProps } from './Bubble';
import clsx from 'clsx';
import { useState } from 'react';

type DisplayType = 'fullName' | 'nickname';

interface Props extends BubbleProps {
  submitted: boolean;
}

export const InputNameBubble = (props: Props) => {
  const [displayType, setDisplayType] = useState<DisplayType>('fullName');
  const [values, setValues] = useState({
    firstName: '',
    lastName: '',
    nickname: '',
  });

  const select = (selected: DisplayType) => () => setDisplayType(selected);

  const isValid =
    displayType === 'fullName'
      ? values.firstName !== '' && values.lastName !== ''
      : values.nickname !== '';

  const confirm = () => {
    switch (displayType) {
      case 'fullName':
        props.onSend([values.lastName, values.firstName].join('\n'));
        break;
      case 'nickname':
        props.onSend(values.nickname);
        break;
    }
  };

  return (
    <>
      <Bubble {...props}>
        <div
          className={`whitespace-pre-line rounded-2xl border px-4 py-3 drop-shadow-sm ${
            props.sender ? 'bg-white' : 'bg-pink-100'
          }`}
        >
          <p>{props.message.text}</p>
        </div>
      </Bubble>
      {!props.submitted && props.message.text !== '次に、あなたのことを教えてください。' && (
        <div className="h-48"></div>
      )}
      {props.isWaiting && !props.submitted && (
        <div
          className={`fixed bottom-0 flex w-full max-w-[480px] transform flex-col justify-center bg-white p-2`}
        >
          {displayType === 'fullName' && (
            <div className="flex-col">
              <p className="m-2 text-lg font-bold text-[#646464]">お名前</p>
              <div className="flex">
                <input
                  type="text"
                  placeholder="姓"
                  className={`${
                    values.lastName != '' ? 'border-[#ED70C2]' : 'border-[#a3a3a4]'
                  } m-2  min-w-0 grow border-b bg-slate-50 px-2 py-1 text-lg focus:border-[#ED70C2] focus:outline-none`}
                  value={values.lastName}
                  onChange={(e) => setValues((prev) => ({ ...prev, lastName: e.target.value }))}
                />
                <input
                  type="text"
                  placeholder="名"
                  className={`${
                    values.firstName != '' ? 'border-[#ED70C2]' : 'border-[#a3a3a4]'
                  } m-2  min-w-0 grow border-b  bg-slate-50 px-2 py-1 text-lg focus:border-[#ED70C2] focus:outline-none`}
                  value={values.firstName}
                  onChange={(e) => setValues((prev) => ({ ...prev, firstName: e.target.value }))}
                />
              </div>
            </div>
          )}
          {displayType === 'nickname' && (
            <div className="flex-col">
              <p className="m-2 text-lg font-bold text-[#646464]">ニックネーム</p>
              <div className="flex">
                <input
                  type="text"
                  placeholder="メェシィ"
                  className={`${
                    values.nickname != '' ? 'border-[#ED70C2]' : 'border-[#a3a3a4]'
                  } m-2 min-w-0 grow border-b bg-slate-50 px-2 py-1 text-lg focus:border-[#ED70C2] focus:outline-none`}
                  value={values.nickname}
                  onChange={(e) => setValues((prev) => ({ ...prev, nickname: e.target.value }))}
                />
              </div>
            </div>
          )}
          <div className="flex">
            {displayType === 'nickname' && (
              <button
                onClick={select('fullName')}
                className={
                  'm-2 w-[30%] rounded-md border border-[#ff66c4] bg-white py-3  text-sm text-sm font-bold text-[#ff66c4]'
                }
              >
                本名
              </button>
            )}
            {displayType === 'fullName' && (
              <button
                onClick={select('nickname')}
                className={
                  'm-2 w-[30%] rounded-md border border-[#ff66c4] bg-white py-3  text-sm text-sm font-bold text-[#ff66c4]'
                }
              >
                ニックネーム
              </button>
            )}
            <button
              className={clsx(
                'bg-brand m-2 grow rounded-md border  bg-[#ff66c4] py-3 font-bold text-white  ',
                isValid ? ' border-[#ff66c4]' : 'opacity-30',
              )}
              disabled={!isValid}
              onClick={confirm}
            >
              確定
            </button>
          </div>
        </div>
      )}
    </>
  );
};
